<template>
  <div class="toggle-container" @click="onToggle" :class="{checked: isChecked}"></div>
</template>

<script>
export default {
  name: 'GrmToggle',
  emits: ['update:isChecked', 'onDisabled'],
  props: {
    isChecked: Boolean,
    disabled: Boolean,
  },
  methods: {
   onToggle(){
     if(this.disabled){
       this.$emit('onDisabled');
       return;
     }
     this.$emit('update:isChecked', !this.isChecked)
     this.onChange();
   },
   onChange(){
    this.$emit('onChange')
   }
  }
}
</script>

<style scoped lang="scss">
.toggle-container{
  position: relative;
  display: flex;
  width: 40px;
  height: 24px;
  padding: 2px;
  border-radius: 24px;
  background: #393939;
  transition: 200ms ease-out;

  &::before {
    content: '';
    position: absolute;
    top: 2px;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    border-radius: 100%;
    background: #FFF;
    transition: 200ms ease-out;
  }

  &:not(.checked) {
    &::before {
      left: 2px;
    }
  }

  &.checked{
    background: #016FF2;
    &::before{
      left: 18px;
    }
  }
}
</style>